import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export const CategoryPill = ({ category, active, onClick }) => {
  return (
    <motion.button
      data-testid={`category-pill-${category.toLowerCase().replace(/\s+/g, '-')}`}
      onClick={onClick}
      className={cn(
        "px-6 py-2.5 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300",
        active
          ? "bg-primary text-white shadow-md"
          : "bg-secondary text-secondary-foreground hover:bg-primary/10"
      )}
      whileTap={{ scale: 0.95 }}
    >
      {category}
    </motion.button>
  );
};
